import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { projectInvitationsQueryOptions } from "@/app/invitations/api/get-project-invitations";
import { projectMembersQueryOptions } from "@/app/members/api/get-project-members";
import { MembersPageSkeleton } from "@/app/members/components/members-page-skeleton";
import { MembersPage } from "@/app/members/page";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/project/members"
)({
  beforeLoad: ({ context: { queryClient }, params }) => {
    const organizationId = params.organizationId;
    const projectId = params.projectId;
    queryClient.prefetchQuery(
      projectMembersQueryOptions(organizationId, projectId)
    );
    queryClient.prefetchQuery(
      projectInvitationsQueryOptions(organizationId, projectId)
    );
  },
  loader: () => ({
    crumb: "Members",
  }),
  errorComponent: RouteErrorBoundary,
  component: () => (
    <Suspense fallback={<MembersPageSkeleton />}>
      <MembersPage />
    </Suspense>
  ),
});
